import { render, staticRenderFns } from "./CourierError.vue?vue&type=template&id=1158cae4"
import script from "./CourierError.vue?vue&type=script&lang=ts"
export * from "./CourierError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports